import { Link } from "react-router-dom";
import { useState } from "react";

export default function Hero() {
  const [query, setQuery] = useState("");

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (!query.trim()) return;
    window.REACT_APP_NAVIGATE("/rank");
    setQuery("");
  };

  return (
    <section className="relative overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=A%20vibrant%20stylized%20anime%20illustration%20of%20a%20young%20manga%20fan%20immersed%20in%20floating%20comic%20pages%20and%20colorful%20story%20panels%2C%20warm%20orange%20coral%20and%20cream%20color%20palette%2C%20dynamic%20composition%2C%20energetic%20youthful%20atmosphere%2C%20high%20detail%20editorial%20artwork&width=1600&height=900&seq=manga-hero-2026&orientation=landscape"
          alt="笨狗漫画网 首页横幅插画"
          className="h-full w-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-background-950/60 via-background-950/40 to-background-950/70"></div>
      </div>

      <div className="relative mx-auto flex min-h-[520px] w-full max-w-7xl flex-col items-center justify-center px-4 py-20 text-center md:min-h-[600px] md:py-24">
        <span className="rounded-full bg-background-50/15 px-4 py-1.5 text-sm text-background-50 backdrop-blur">
          <i className="ri-fire-fill mr-1 text-accent-400" aria-hidden="true"></i>
          每日更新漫画榜单与追更推荐
        </span>

        <h1 className="mt-6 font-heading text-4xl leading-tight text-background-50 md:text-6xl">
          追更不迷路，<span className="text-accent-400">好漫不错过</span>
        </h1>

        <p className="mt-5 max-w-2xl text-base leading-relaxed text-background-100 md:text-lg">
          在笨狗漫画网看排行榜、编辑推荐、精选书单与社区讨论，还有海量评分帮你快速决定追哪部热门作品。
        </p>

        <form
          onSubmit={handleSearch}
          className="mt-8 flex w-full max-w-xl flex-col gap-3 sm:flex-row"
        >
          <div className="flex flex-1 items-center gap-2 rounded-full bg-background-50 px-5 py-3 shadow-sm">
            <i className="ri-search-line text-foreground-500" aria-hidden="true"></i>
            <input
              type="text"
              value={query}
              onChange={(e) => setQuery(e.target.value)}
              placeholder="搜一搜你想追的漫画"
              className="w-full bg-transparent text-sm text-foreground-900 outline-none placeholder:text-foreground-400"
            />
          </div>
          <button
            type="submit"
            className="whitespace-nowrap rounded-full bg-accent-500 px-7 py-3 text-sm font-bold text-background-50 transition-colors hover:bg-accent-600"
          >
            立即搜索
          </button>
        </form>

        <div className="mt-10 flex flex-wrap items-center justify-center gap-6 text-background-100">
          <div className="text-center">
            <p className="font-heading text-2xl text-background-50">2.4w+</p>
            <p className="mt-1 text-xs">收录作品</p>
          </div>
          <div className="h-8 w-px bg-background-50/30"></div>
          <div className="text-center">
            <p className="font-heading text-2xl text-background-50">180w+</p>
            <p className="mt-1 text-xs">追更用户</p>
          </div>
          <div className="h-8 w-px bg-background-50/30"></div>
          <div className="text-center">
            <p className="font-heading text-2xl text-background-50">60w+</p>
            <p className="mt-1 text-xs">书单收藏</p>
          </div>
          <div className="h-8 w-px bg-background-50/30"></div>
          <div className="text-center">
            <p className="font-heading text-2xl text-accent-400">9.8w+</p>
            <p className="mt-1 text-xs">讨论话题</p>
          </div>
        </div>

        <Link
          to="/rank"
          className="mt-10 inline-flex items-center gap-2 rounded-full border border-background-50/40 px-6 py-2.5 text-sm font-medium text-background-50 backdrop-blur transition-colors hover:bg-background-50 hover:text-foreground-900"
        >
          查看完整排行榜 <i className="ri-arrow-right-line" aria-hidden="true"></i>
        </Link>
      </div>
    </section>
  );
}